export const i18n_namespace = 'interior-damage-photos';
